import { alpha } from '@mui/material/styles';
import { SWIFTFOX_PALETTE } from '../palette';

const SHADOW_BASE = '#000000';

export const darkTheme = {
	palette: {
		mode: 'dark',
		text: {
			header: SWIFTFOX_PALETTE.neutral['10-almostWhite'],
			primary: SWIFTFOX_PALETTE.neutral['20-offWhite'],
			secondary: SWIFTFOX_PALETTE.neutral['30-lightGrey'],
			disabled: SWIFTFOX_PALETTE.neutral['40-justGrey'],
			_link: {
				default: SWIFTFOX_PALETTE.blue['20-frostedAzure'],
				visited: SWIFTFOX_PALETTE.purple['10-lilacMist']
			},
			_states: {
				selected: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.16),
				hover: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.08),
				focus: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.12),
				focusVisible: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.3)
			},
			_fontColour: {
				body: SWIFTFOX_PALETTE.neutral['20-offWhite'],
				primary: SWIFTFOX_PALETTE.neutral['10-almostWhite']
			},
			highlight: {
				background: SWIFTFOX_PALETTE.blue['10-icyMist'],
				foreground: SWIFTFOX_PALETTE.blue['40-coreBlue']
			}
		},
		primary: {
			main: SWIFTFOX_PALETTE.blue['40-coreBlue'],
			dark: SWIFTFOX_PALETTE.blue['30-skywave'],
			light: alpha(SWIFTFOX_PALETTE.blue['30-skywave'], 0.25),
			contrastText: SWIFTFOX_PALETTE.neutral['70-nearlyBlack'],
			_states: {
				hover: alpha(SWIFTFOX_PALETTE.blue['30-skywave'], 0.25),
				selected: alpha(SWIFTFOX_PALETTE.blue['40-coreBlue'], 0.75),
				focus: SWIFTFOX_PALETTE.blue['30-skywave'],
				focusVisible: alpha(SWIFTFOX_PALETTE.blue['30-skywave'], 0.45),
				outlinedBorder: alpha(SWIFTFOX_PALETTE.blue['20-frostedAzure'], 0.5),
				fill: alpha(SWIFTFOX_PALETTE.blue['30-skywave'], 0.25)
			}
		},
		secondary: {
			main: SWIFTFOX_PALETTE.blue['20-frostedAzure'],
			dark: SWIFTFOX_PALETTE.blue['30-skywave'],
			light: SWIFTFOX_PALETTE.blue['50-deepOcean'],
			contrast: SWIFTFOX_PALETTE.blue['60-midnight'],
			_states: {
				hover: alpha(SWIFTFOX_PALETTE.blue['30-skywave'], 0.25),
				focus: SWIFTFOX_PALETTE.blue['40-coreBlue'],
				focusVisible: alpha(SWIFTFOX_PALETTE.blue['30-skywave'], 0.45),
				outlinedBorder: SWIFTFOX_PALETTE.blue['50-deepOcean']
			}
		},
		action: {
			active: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.56),
			hover: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.08),
			selected: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.16),
			focus: alpha(SWIFTFOX_PALETTE.blue['30-skywave'], 0.16),
			disabled: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.38),
			disabledBackground: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.1)
		},
		common: {
			white_states: {
				main: SWIFTFOX_PALETTE.neutral['10-almostWhite'],
				hover: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.08),
				selected: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.16),
				focus: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.12),
				focusVisible: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.3),
				outlinedBorder: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.5)
			}
		},
		background: {
			default: SWIFTFOX_PALETTE.neutral['70-nearlyBlack'],
			'paper-elevation-0': SWIFTFOX_PALETTE.neutral['70-nearlyBlack'],
			// NOTE FOR KIERNAN: Missing a brand colour for these:
			'paper-elevation-1': '#2D2D2F',
			'paper-elevation-2': '#373739',
			'paper-elevation-3': SWIFTFOX_PALETTE.neutral['60-darkGrey'],
			'paper-colour': SWIFTFOX_PALETTE.neutral['60-darkGrey']
		},
		divider: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.3),
		elevation: {
			outlined: alpha(SWIFTFOX_PALETTE.neutral['10-almostWhite'], 0.3),
			shadow: {
				'alpha-1': alpha(SHADOW_BASE, 0.01),
				'alpha-2': alpha(SHADOW_BASE, 0.02),
				'alpha-3': alpha(SHADOW_BASE, 0.03),
				'alpha-4': alpha(SHADOW_BASE, 0.04),
				'alpha-5': alpha(SHADOW_BASE, 0.08),
				'alpha-6': alpha(SHADOW_BASE, 0.12),
				'alpha-7': alpha(SHADOW_BASE, 0.14),
				'alpha-8': alpha(SHADOW_BASE, 0.18),
				'alpha-9': alpha(SHADOW_BASE, 0.22)
			}
		},
		_components: {
			timelineDot: SWIFTFOX_PALETTE.blue['40-coreBlue'],
			avatar: {
				fill: SWIFTFOX_PALETTE.neutral['50-midGrey']
			},
			featureMenu: '#2D2D2F',
			switch: {
				slideFill: SWIFTFOX_PALETTE.neutral['10-almostWhite']
			},
			rating: {
				activeFill: SWIFTFOX_PALETTE.orange['30-highlight']
			},
			snackbar: {
				fill: SWIFTFOX_PALETTE.neutral['60-darkGrey']
			},
			tooltip: {
				fill: SWIFTFOX_PALETTE.blue['20-frostedAzure']
			}
		},
		error: {
			main: '#D43D3D',
			dark: '#A32828',
			light: '#FFB2BE',
			_states: {
				hover: 'rgba(222, 105, 105, 0.04)',
				selected: 'rgba(222, 105, 105, 0.08)',
				focusVisible: 'rgba(222, 105, 105, 0.3)',
				outlinedBorder: 'rgba(222, 105, 105, 0.5)'
			},
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite']
		},
		warning: {
			main: '#9A5A00',
			dark: '#6B3E00',
			light: '#FFE0A8',
			_states: {
				hover: 'rgba(255, 167, 38, 0.04)',
				selected: 'rgba(255, 167, 38, 0.08)',
				focusVisible: 'rgba(255, 167, 38, 0.3)',
				outlinedBorder: 'rgba(255, 167, 38, 0.5)'
			},
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite']
		},
		info: {
			main: '#0F6E92',
			dark: '#094A62',
			light: '#BFE9F6',
			_states: {
				hover: 'rgba(13, 145, 232, 0.04)',
				selected: 'rgba(13, 145, 232, 0.08)',
				focusVisible: 'rgba(13, 145, 232, 0.3)',
				outlinedBorder: 'rgba(13, 145, 232, 0.5)'
			},
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite']
		},
		success: {
			main: '#187F5E',
			dark: '#0D5A45',
			light: '#C9F2E6',
			_states: {
				hover: 'rgba(24, 127, 94, 0.04)',
				selected: 'rgba(24, 127, 94, 0.08)',
				focusVisible: 'rgba(24, 127, 94, 0.3)',
				outlinedBorder: 'rgba(24, 127, 94, 0.5)'
			},
			contrastText: SWIFTFOX_PALETTE.neutral['10-almostWhite']
		}
	} as const
} as const;
